import i18n from 'i18next'
//import Backend from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'

i18n
    //.use(Backend)
    .use(initReactI18next)
    .init({
        lng: 'en',
        //backend: {
            /* translation file path */
           // loadPath: '/assets/i18n/{{ns}}/{{lng}}.json'
       // },
        fallbackLng: 'en',
        debug: false,
        /* can have multiple namespace, in case you want to divide a huge translation into smaller pieces and load them on demand */
       // ns: ['translations'],
       // defaultNS: 'translations',
        keySeparator: false,
        interpolation: {
            escapeValue: false,
            formatSeparator: ','
        },
        react: {
            wait: true,
            useSuspense: false
        },
        resources: {
            en: {
                translation: {
                    "logo.title": "Keeping You Well, While You\u2019re Away \u00AE",
                    "step.steps": "of",
                    "step1.title": "Hi I'm Sonny,I'll be assisting you in choosing the right health plan.<br/>Let's get started!",
                    "step1.firstname": "First Name",
                    "step1.lastname": "Last Name",
                    "btn.save": "Next",
                    "step2.title": "2 of 6",
                    "step2.email": "Email",
                    "step2.phone": "Phone",
                    "btn.back": "Previous",
                    "step3.title": "3 of 6",
                    "step3.destination": "Destination",
                    "step3.type_of_insurance": "Type of insurance",
                    "select.init": "Please select..",
                    "step4.title": "4 of 6",
                    "step4.country_of_residency": "Country of Residency",
                    "step4.nationality": "Nationality",
                    "step4.length_of_stay": "Length of stay",
                    "step5.title": "Confirm your Details",
                    "step5.subtitle": "Click Confirm if the following details have been correctly entered",
                    "success.title": "Congratulations!",
                    "success.title1": "All Steps Are Successfully Saved",
                    "success.loading": "loading...",
                    "success.noitems": "No Items found!",
                    "lang.en": "English",
                    "lang.es": "Spanish",
                    "lang.fr": "French",
                    "lang.pt": "Portuguese",
                    "step5.confirm": "confirm",
                    "lang.country": "COUNTRY",
                    "step2.hi": "Great to meet you",
                    "step4.thanks": "Thanks",
                    "success.plandetails": "Plan Detail",
                    "success.requestquote": "Request a Quote",
                    "success.startquote": "Start a Quote",
                    "success.allplans": "See Our Plans",
                    "success.newquote": "Start New Quote",
                    "success.close": "Close",
                    "success.quicklook": "Quick Look",
                    "step3.message": "Oops - I'm sorry but your Nationality and Destination cannot be the same.",
                    "seo.title": "Start an Expat Insurance Quote with SONNY  | WellAway",
                    "seo.description": "Use our easy SONNY system to find the best expat health insurance.",
                    "step1.auth_message": "We're sorry you do not have authorization to use our Sonny App. Please contact Email address",
                    "step5.universities": "University",
                    "step5.visa": "Visa"
                   
                }
            },
            es: {
                translation: {
                    "logo.title": "Keeping You Well, While You\u2019re Away \u00AE",
                    "step.steps": "de",
                    "step1.title": "Hola, soy Sonny, te ayudar\u00E9 a elegir el plan de salud adecuado. <br/> ?Comencemos!",
                    "step1.firstname": "Nombre",
                    "step1.lastname": "Apellido",
                    "btn.save": "Siguiente",
                    "step2.title": "2 de 6",
                    "step2.email": "Correo electronico",
                    "step2.phone": "Telefono",
                    "btn.back": "Anterior",
                    "step3.title": "3 de 6",
                    "step3.destination": "Nacionalidad",
                    "step3.type_of_insurance": "Tipo de seguro",
                    "select.init": "Por favor seleccione ..",
                    "step4.title": "4 de 6",
                    "step4.country_of_residency": "Pa\u00EDs de residencia",
                    "step4.nationality": " Lugar de Destino",
                    "step4.length_of_stay": "Duracion de estancia",
                    "step5.title": "Confirme sus detalles",
                    "step5.subtitle": "Haga clic en Confirmar si los siguientes detalles se han ingresado correctamente",
                     "success.title": "Felicidades!",
                    "success.title1": "Todos los pasos se guardan con \u00E9xito",
                    "success.loading": "cargando...",
                    "success.noitems": "?No se encontraron art\u00EDculos!",
                    "lang.en": "Ingles",
                    "lang.es": "Espanol",
                    "lang.fr": "Frances",
                    "lang.pt": "Portugu\u00E9s",
                    "step5.confirm": "confirme",
                    "lang.country": "PAIS",
                    "step2.hi": "Un placer conocerle",
                    "step4.thanks": "Gracias",
                    "success.plandetails": "Detalles del plan",
                    "success.requestquote": "Solicitar cotizacion",
                    "success.startquote": "Iniciar un presupuesto",
                    "success.allplans": "Mira nuestros planes",
                    "success.newquote": "Iniciar nueva cotizacion",
                    "success.close": "Cerrar",
                    "success.quicklook": "Vistazo R\u00E1pido",
                    "step3.message": "Atencion! Lo sentimos, pero tu nacionalidad y tu lugar de destino no pueden ser el mismo.",
                    "seo.title": "Solicita una Cotizaci\u00F3n para el Seguro M\u00E9dico para Expatriados con el Sistema SONNY | WellAway",
                    "seo.description": "Utiliza nuestro sencillo sistema SONNY para encontrar el mejor seguro m\u00E9dico para expatriados.",
                    "step1.auth_message": "We're sorry you do not have authorization to use our Sonny App. Please contact Email address",
                    "step5.universities": "Universidad",
                    "step5.visa": "Visa"
                }
            },
            fr: {
                translation: {
                    "logo.title": "Keeping You Well, While You\u2019re Away \u00AE",
                    "step.steps": "de",
                    "step1.title": "Bonjour, je suis Sonny, je vais vous aider\u00E0 choisir le bon plan de sant\u00E9 . <br/> Commen\u00E7ons!",
                    "step1.firstname": "Pr\u00E9nom",
                    "step1.lastname": "Nom de Famille",
                    "btn.save": "Suivant",
                    "step2.title": "2 sur 6",
                    "step2.email": "Email",
                    "step2.phone": "T\u00E9l\u00E9phone",
                    "btn.back": "Pr\u00E9c\u00E9dent",
                    "step3.title": "3 sur 6",
                    "step3.destination": "Destination",
                    "step3.type_of_insurance": "Type d'assurance",
                    "select.init": "Veuillez s\u00E9lectionner..",
                    "step4.title": "4 sur 6",
                    "step4.country_of_residency": "Pays de r\u00E9sidence",
                    "step4.nationality": "Nationalit\u00E9",
                    "step4.length_of_stay": "Dur\u00E9e du s\u00E9jour",
                    "step5.title": "Confirmer vos informations",
                    "step5.subtitle": "Cliquez sur Confirmer si les informations suivantes ont \u00E9t\u00E9 correctement saisies",
                     "success.title": "Toutes nos f\u00E9licitations",
                    "success.title1": "Toutes les \u00E9tapes sont enregistr\u00E9es avec succ\u00E8s",
                    "success.loading": "chargement...",
                    "success.noitems": "Aucun \u00E9l\u00E9ment trouv\u00E9!",
                    "lang.en": "Anglais",
                    "lang.es": "Espagnol",
                    "lang.fr": "Fran\u00E7ais",
                    "lang.pt": "Portugais",
                    "step5.confirm": "confirmer",
                    "lang.country": "PAYS",
                    "step2.hi": "Ravi de vous rencontrer",
                    "step4.thanks": "Merci",
                    "success.plandetails": "D\u00E9tails du plan",
                    "success.requestquote": "Demander un devis",
                    "success.startquote": "Obtenir un devis",
                    "success.allplans": "Voir nos plans",
                    "success.newquote": "Commencer un devis",
                    "success.close": "Fermer",
                    "success.quicklook": "Coup D'oeil",
                    "step3.message": "D\u00E9sol\u00E9 \u2013 Votre pays de destination ne peut \u00EAtre le m\u00EAme que votre pays de citoyennet\u00E9",
                    "seo.title": "Commencez un devis d'assurance expatri\u00E9 avec SONNY | WellAway",
                    "seo.description": "Utilisez notre syst\u00E8me SONNY pour trouver la meilleure assurance sant\u00E9 pour expatri\u00E9.",
                    "step1.auth_message": "We're sorry you do not have authorization to use our Sonny App. Please contact Email address",
                    "step5.universities": "Uuniversit\u00E9",
                    "step5.visa": "Visa"
                }
            },
            pt: {
                translation: {
                    "logo.title": "Keeping You Well, While You\u2019re Away \u00AE",
                    "step.steps": "de",
                    "step1.title": "Hola, soy Sonny, te ayudar\u00E9 a elegir el plan de salud adecuado. <br/> ?Comencemos!",  //?
                    "step1.firstname": "Nome",
                    "step1.lastname": "Sobrenome",
                    "btn.save": "Pr\u00F3ximo", 
                    "step2.title": "2 de 6",
                    "step2.email": "Correio eletr\u00F4nico",
                    "step2.phone": "Telefone",
                    "btn.back": "Anterior",
                    "step3.title": "3 de 6",
                    "step3.destination": "Destno",
                    "step3.type_of_insurance": "Tipo de seguro",
                    "select.init": "Por favor seleccione ..",
                    "step4.title": "4 de 6",
                    "step4.country_of_residency": "Pa\u00EDs de residencia",
                    "step4.nationality": "Nacionalidade",
                    "step4.length_of_stay": "Tempo de perman\u00EAncia",
                    "step5.title": "Confirme sus detalles",
                    "step5.subtitle": "Haga clic en Confirmar si los siguientes detalles se han ingresado correctamente",
                     "success.title": "Felicidades!",
                    "success.title1": "Todos los pasos se guardan con \u00E9xito",
                    "success.loading": "carregando ...�",
                    "success.noitems": "?No se encontraron art\u00EDculos!",
                    "lang.en": "Ingl\u00EAs",
                    "lang.es": "Espanhol",
                    "lang.fr": "Franc\u00EAs",
                    "lang.pt": "Portugu\u00EAs",
                    "step5.confirm": "confirme",
                    "lang.country": "PA\u00CDS",
                    "step2.hi": "Um prazer conhec\u00EA-lo",
                    "step4.thanks": "Obrigado",
                    "success.plandetails": "Detalhes do plano",
                    "success.requestquote": "solicitar uma cota\u00E7\u00E3o",
                    "success.startquote": "Iniciar uma cota\u00E7\u00E3o",
                    "success.allplans": "Veja nossos planos",
                    "success.newquote": "Come\u00E7ar uma nova cota\u00E7\u00E3o",
                    "success.close": "Fechar",
                    "success.quicklook": "Uma Olhada",
                    "step3.message": "Ops � Desculpe, mas sua nacionalidade e destino n\u00E3o podem ser iguais.",
                    "seo.title": "Start an Expat Insurance Quote with SONNY  | WellAway",
                    "seo.description": "Use our easy SONNY system to find the best expat health insurance.",
                    "step1.auth_message": "We're sorry you do not have authorization to use our Sonny App. Please contact Email address",
                    "step5.universities": "Universidade",
                    "step5.visa": "Visto"
                }
            },

        },
    })

export default i18n